import range from 'lodash/range';

export default {
  /**
   * Generate pagination blocks for a given total number of pages and current page.
   * This function creates an array of page numbers to be displayed in the pagination component.
   * It ensures that the pagination is centered around the current page and does
   * not exceed the maximum number of blocks.
   */
  generatePaginationBlocks({ currentPage = 1, offset = 3, totalPages = 10 }) {
    // Calculate the start and end page numbers based on the current page and offset
    const startPage = Math.max(currentPage - offset, 1);
    const endPage = Math.min(currentPage + offset, totalPages);

    // Generate an array of page numbers within the calculated range
    const pages = range(startPage, endPage + 1);

    // Map the generated page numbers to an array of objects with isActive property
    return pages.map((page) => ({
      isActive: page === currentPage,
      page,
    }));
  },
};
